var ValueJS = ValueJS || {};

ValueJS.BackToTop = function() {

    var _btn = $('.scroll-to-top');
    var _offset = 100;

    var _initialized = false;

    var _init = function() {
        if (!_initialized) {
            $(window).on('scroll', function() {
                _windowScroll();
            });
            _windowScroll();
            _btn.find('a').on('click', function(e) {
                e.preventDefault();
                ValueJS.SmoothScroll.scroll($('#top'));
            })
            _initialized = true;
        }
    }

    var _windowScroll = function() {
        let scrollPos = $(window).scrollTop();
        // show / hide
        _btn.css('right', (scrollPos > 20 ? '-111px' : '-145px'));
        // update scroll progress bar
        let progress = (scrollPos / ($(document).height() - $(window).height())) * 100;
        $('.scroll-to-top__progress-bar').css('width', progress + '%');
    }

    /** PUBLIC API **/
    return {
        init : function() {return _init();},
    };

}();

$(function() {
    ValueJS.BackToTop.init();
});
